import { PayloadAction } from '@reduxjs/toolkit';
import { IRootState } from './types';

const reducers = {
  setPlatformData: (state: IRootState, action: PayloadAction<IRootState['platformData']>) => ({
    ...state,
    platformData: action.payload,
  }),
  setToggleDrawer: (state: IRootState, action: PayloadAction<IRootState['isOpenDrawer']>) => ({
    ...state,
    isOpenDrawer: action.payload,
  }),
  setIsOpenPagesNav: (state: IRootState, action: PayloadAction<IRootState['isOpenPagesNav']>) => ({
    ...state,
    isOpenPagesNav: action.payload,
  }),
  setPasswordValidation: (state: IRootState, action: PayloadAction<{ key: string; value: boolean | null }>) => {
    const { payload } = action;

    return {
      ...state,
      passwordValidation: {
        ...state.passwordValidation,
        [payload.key]: payload.value,
      },
    };
  },
  toggleRangePicker: (state: IRootState, action: PayloadAction<IRootState['isOpenRangePicker']>) => ({
    ...state,
    isOpenRangePicker: action.payload,
  }),
  selectedFilterItems: (state: IRootState, action: PayloadAction<IRootState['selectedFilterItems']>) => ({
    ...state,
    selectedFilterItems: action.payload,
  }),
  setIsPrintMode: (state: IRootState, action: PayloadAction<IRootState['isPrintMode']>) => ({
    ...state,
    isPrintMode: action.payload,
  }),
  setSelectedLang: (state: IRootState, action: PayloadAction<IRootState['selectedLanguage']>) => ({
    ...state,
    selectedLanguage: action.payload,
  }),
  setIsOpenReleaseNav: (state: IRootState, action: PayloadAction<IRootState['isOpenReleaseNav']>) => ({
    ...state,
    isOpenReleaseNav: action.payload,
  }),
  setIsOpenPricingDialog: (state: IRootState, action: PayloadAction<IRootState['isOpenPricingDialog']>) => ({
    ...state,
    isOpenPricingDialog: action.payload,
  }),
};

export {
  reducers,
};
